import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class GameService extends BaseService {
    apiGetGames() {
        return this.post(API_URL + '/api/v2/games', {
            account: store.state.account
        }).then(response => {
            if (response.data.status == 'success') {
                return response.data.results;
            }
        }).catch(err => {
            throw err.response.data;
        })
    }

    apiGetNextDraws() {
        return this.post(API_URL + '/api/v2/nextdraws', {
            account: store.state.account
        }).then(response => {
            if (response.data.status == 'success') {
                return response.data.results;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new GameService();
